import React from 'react'
import { GlossaryListGroup, GlossaryListItemBlok } from './types'
import { v4 as uuid } from 'uuid'

export const useGlossaryGroups = (glossaryItems: GlossaryListItemBlok[]) => {
  const groups: GlossaryListGroup[] = React.useMemo(() => {
    let groupArray: GlossaryListGroup[] = []
    const id = uuid()

    glossaryItems.forEach(item => {
      const existingGroup = groupArray.find(grp => grp.letter === item.headline[0].toUpperCase())
      if (existingGroup) {
        existingGroup.items.push(item)
      } else {
        groupArray.push({
          letter: item.headline[0].toUpperCase(),
          id: `${id}-${item.headline[0].toUpperCase()}`,
          items: [item],
        })
      }
    })

    return groupArray.sort((a, b) => a.letter.localeCompare(b.letter))
  }, [glossaryItems])

  return groups
}
